import store_operation from "@/store/mods/caisse/operations"
import DateFilter from '@/components/date-filter';
import $ from 'jquery';

export default {
    name: 'creance-patients',
    components: {
        DateFilter
    },
    props: {
        is_dashboard: {
            type: Number,
            default: () => 0
        }
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_error: false,
            list_creance_patients: [],

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false,
            fields: [
                { key: 'patient', label: 'Patient' },
                { key: 'telephone', label: 'Téléphone' },
                { key: 'amount_initial', label: 'Dû initial' },
                { key: 'amount_acomptes', label: 'Acomptes' },
                { key: 'total_rap', label: 'Reste à recouvrer' },
                { key: 'actions', label: 'Actions' }
            ],

            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,

            tot_differes: 0,
            tot_reste_a_payer: 0,
            tot_initial: 0,
            tot_acomptes: 0,
            has_recouvrement_detail: false,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter-creances').modal('show')
                }
            }            
        },

        curr_month() {
            this.list_creance_patients = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.is_month = true
            this.current_date_filter = data
            this.getListeCreancePatients(data)
        },
    },
    
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.monthOfYear[0].lib = "Toutes les périodes"

        this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", {});
        this.$store.commit("SET_PAYMENT_ACTION", '');

        const data = {
            month: this.curr_month.id,
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
        }
        this.current_date_filter = data
        this.getListeCreancePatients(data)
    },

    methods: {
        getListeCreancePatients(data) {
            this.is_error = false
            this.is_loading = true

            store_operation.getPatientCreances(data).then((response) => {
                this.list_creance_patients = (response.patients)?response.patients:[]
                this.tot_differes = Number(response.total_differes) || 0
                this.tot_reste_a_payer = Number(response.total_rap) || 0
                this.has_recouvrement_detail = response.total_initial != null && response.total_acomptes != null
                this.tot_initial = this.has_recouvrement_detail ? Number(response.total_initial) : 0
                this.tot_acomptes = this.has_recouvrement_detail ? Number(response.total_acomptes) : 0
                if (this.list_creance_patients.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            }).catch(() => {
                this.is_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.list_creance_patients = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false
            this.getListeCreancePatients(data)
        },

        goToPayment(data_type, item) {
            const selected_patient = {
                patient_id: parseInt(item.patient_id),
                nom: item.patient,
                prenoms: "",
                nom_patient: item.patient,
                sexe: item.sexe,
                telephone_mobile: item.telephone,
                age: item.age,
                num_dossier: item.num_dossier
            }

            this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", selected_patient);
            this.$store.commit("SET_PAYMENT_ACTION", data_type);
            this.$router.push({ "path": "/factures/patients-operations" })
        },
    }
}
